<template>
  <div class="chat_mobile" ref="chat_mobile" v-loading="loading">
    <iframe src="https://tb.53kf.com/code/client/daa8b04cbb02352f2449873bb79aebfa8/1"
            class="mobs"
            scrolling="no"
            frameborder="0"
    >
    </iframe>
    <!--        <botmob></botmob>-->

    <floating-ball :show-or-not="showFloatingBall"
                   @showForm="handleReverse">
      <div class="show-assist-btn">
        <img src="../../public/statics/img/chat/help@2x.png"
             alt=""
             class="blub-icon"
        >
        <p class="btn-title">申请远程协助</p>
      </div>
    </floating-ball>

    <van-popup v-model="showAssistForm"
               position="bottom"
               class="assist-form"
               @close="closeForm"
    >
      <div class="head">
        <div class="head-left">
          <img src="../../public/statics/img/chat/blub.svg"
               alt=""
               class="blub-icon"
          >
          <span class="form-title">远程协助</span>
        </div>
        <img src="../../public/statics/img/chat/cross.svg"
             alt=""
             class="close-icon"
             @click="closeForm"
        />
      </div>
      <van-form @submit="submitInfo"
                class="form-wrapper"
                ref="formRef"
      >
        <van-field
            v-model="assistInfo.contract"
            name="联系人"
            placeholder="联系人 必填"
            class="input-wrapper"
            :rules="[
                {required: true, trigger: 'onBlur', message: '请输入联系人'},
                {validator: contractValidator, message: '最多输入50个字'}
            ]"
        />
        <van-field
            v-model="assistInfo.telNum"
            name="联系电话"
            placeholder="联系电话 必填"
            class="input-wrapper"
            :rules="[
                {required: true, trigger: 'onBlur', message: '请输入联系电话'},
                {validator: telNameValidator, message: '最多输入15个字'}
            ]"
        />
        <van-field
            v-model="assistInfo.coName"
            name="单位名称"
            placeholder="单位名称 必填"
            class="input-wrapper"
            :rules="[
                {required: true, trigger: 'onBlur', message: '请输入单位名称'},
                {validator: coNameValidator, message: '最多输入50个字'}
            ]"
        />
        <van-field
            v-model="assistInfo.applyReason"
            rows="4"
            type="textarea"
            name="申请原因"
            placeholder="申请原因"
            class="input-wrapper"
            :rules="[
                {validator: applyReasonValidator, message: '最多输入255个字'}
            ]"
        />
        <van-button round
                    block
                    color="#3974AB"
                    class="apply-btn"
        >
          立即申请
        </van-button>
      </van-form>
    </van-popup>

  </div>
</template>

<script>
import top_mobile from "../components/top_mobile";
import botmob from "../components/botmobile";
import floatingBall from "../components/floatingBall";
import {Toast} from "vant";
import {auth} from "../request/api";

export default {
  name: "chat_mobile",
  data() {
    return {
      loading: true,
      showAssistForm: false,
      showFloatingBall: true,
      assistInfo: {
        contract: '',
        telNum: '',
        coName: '',
        applyReason: ''
      },
      passValidate: false,
    }
  },
  components: {
    top_mobile,
    botmob,
    floatingBall
  },
  mounted() {
    this.getBrowserInterfaceSize();
    setTimeout(() => {
      this.loading = false;
    }, 500)
  },
  methods: {
    handleReverse() {
      this.showFloatingBall = false
      this.showAssistForm = true
    },

    closeForm() {
      this.showAssistForm = false
      this.showFloatingBall = true
      this.$refs.formRef.resetValidation()
      for(let item in this.assistInfo) {
        this.assistInfo[item] = ''
      }
    },

    submitInfo() {
      let url = '/v1/assistance/apply'
      let data = {
        tel_name: this.assistInfo.contract,
        telephone: this.assistInfo.telNum,
        company_name: this.assistInfo.coName,
        reason: this.assistInfo.applyReason
      }
      auth(url, data).then(res => {
        if(res.data.code == 1) {
          Toast.success('已提交')
          this.$refs.formRef.resetValidation()
          for(let item in this.assistInfo) {
            this.assistInfo[item] = ''
          }
          this.showAssistForm = false
          this.showFloatingBall = true
        } else {
          Toast(res.data.msg)
        }
      })
    },

    contractValidator(val) {
      return val.length <= 50
    },
    telNameValidator(val) {
      return val.length <= 15
    },
    coNameValidator(val) {
      return val.length <= 50
    },
    applyReasonValidator(val) {
      return val.length <= 255
    },

    getBrowserInterfaceSize() {
      var pageWidth = window.innerWidth;
      var pageHeight = window.innerHeight;
      if (typeof pageWidth != "number") { //在标准模式下面
        if (document.compatMode == "CSS1Compat") {
          pageWidth = document.documentElement.clientWidth;
          pageHeight = document.documentElement.clientHeight;
        } else {
          pageWidth = document.body.clientWidth;
          pageHeight = window.body.clientHeight;
        }
      }
      console.log(pageHeight);
      this.$refs.chat_mobile.style.height = pageHeight + 'px'
    }
  },
}
</script>

<style scoped lang='scss'>
.chat_mobile {
  width: 24rem;
  height: 100vh;
  background: #FBA962;

  .mobs {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .show-assist-btn {
    position: relative;

    .blub-icon {
      width: 17.33px;
      height: 22.9px;
      margin-top: 6px;
    }

    .btn-title {
      width: 50px;
      position: absolute;
      left: 50%;
      transform: translatex(-50%);
      margin-top: 3px;
      line-height: 14px;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0;
      color: #fff;

      //margin-top: 3px;
    }
  }

  .assist-form {
    background: #FFFFFF;
    border: 1px solid #F8F8F8;
    box-shadow: 0px -5px 10px rgba(210, 210, 219, 0.34);
    opacity: 1;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100vw;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 10px;
    box-sizing: border-box;

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .head-left {
        .blub-icon {
          width: 17.23px;
          height: 22.76px;
          margin-right: 8px;
        }

        .form-title {
          font-size: 20px;
          font-family: "PingFang SC";
          font-weight: bold;
          color: #3974AB;
          opacity: 1;
        }
      }

      .close-icon {
        width: 12px;
        height: 12px;
      }
    }

    .form-wrapper {
      position: relative;

      .input-wrapper {
        font-size: 14px;
        font-family: "PingFang SC";
        font-weight: bold;
      }

      /deep/ .van-field__control {
        background: #F9F9F9;
        height: 40px;
        color: #000;
        padding-left: 10px;
      }

      /deep/ .van-field__control::placeholder {
        color: #3974AB;
        opacity: 0.46;
      }

      /deep/ .van-button__text {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
      }

      .apply-btn {
        width: 160px;
        height: 40px;
        margin: 10px auto 35px;
      }
    }
  }
}
</style>
